import React from "react";
import { Link } from "react-router-dom";
import Wrapper from "../components/Wrapper";
import { translations } from "../langauge";
import { useLang } from "../context/LanguageContext";

const Homepage = () => {
  const { lang } = useLang();

  const navlinks = [
    { id: 1, title: translations[lang].about, link: "/about-us" },
    { id: 2, title: translations[lang].apps, link: "/laban" },
    { id: 3, title: translations[lang].team, link: "/team" },
    { id: 4, title: translations[lang].pricing, link: "/pricing" },
    { id: 5, title: translations[lang].contact, link: "/contact-us" },
  ];

  return (
    <Wrapper>
      <div className="mainWrapperInnerDiv">
        <div className="mainWrapperInnerDivtwo">
          <div className="row h-100">
            <div className="col-lg-6 col-md-12 col-12 d-flex align-items-center justify-content-center  mainRightContainer">
              <div className="mainImg">
                <img src="./images/mainimg.png" alt="gemenu" />
              </div>
            </div>
            <div className="col-lg-6 col-md-12 col-12 d-flex justify-content-center mainRightContainer">
              <div className="navbarDiv homeNavDiv w-100">
                <ul>
                  {navlinks?.map((nav) => (
                    <li key={nav.id}>
                      <Link to={nav.link} data-discover="true">
                        {nav.title}
                      </Link>
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Wrapper>
  );
};

export default Homepage;
